import { Link } from "react-router-dom";
import { isClinicPortal } from "../../utils/portalHost";
import { SITE_ORIGIN } from "../../config/site";
import { LEGAL_PATHS, LEGAL_PUBLIC_ENABLED } from "../../constants/legalPaths";
import L from "../../constants/baysportLabels";
import fs from "./legalFooter.module.css";

/** Абсолютный URL юр. документа на основном сайте платформы. */
export function getLegalDocHref(doc) {
  const path = LEGAL_PATHS[doc];
  if (!path) return null;
  return `${SITE_ORIGIN}${path}`;
}

/** Ссылка на юр. документ: на платформе — SPA Link, снаружи / в новой вкладке — абсолютный URL. */
export function LegalDocLink({
  doc,
  children,
  className,
  target,
  rel,
  onClick,
  ...rest
}) {
  const path = LEGAL_PATHS[doc];
  if (!path || !LEGAL_PUBLIC_ENABLED) {
    return <span className={className}>{children}</span>;
  }

  const openBlank = target === "_blank" || isClinicPortal();
  const handleClick = (e) => {
    // Ссылка внутри <label> чекбокса — не даём клику «провалиться» в label.
    e.stopPropagation();
    onClick?.(e);
  };

  if (openBlank) {
    // Всегда основной сайт (SITE_ORIGIN), не поддомен клуба и не угадывание app.*
    const href = getLegalDocHref(doc);
    return (
      <a
        href={href}
        className={className}
        target="_blank"
        rel={rel || "noopener noreferrer"}
        onClick={handleClick}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={path} className={className} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}

export function LegalFooterLinks({ className, compact = false }) {
  const year = new Date().getFullYear();
  const cls = [fs.root, className].filter(Boolean).join(" ");

  if (!LEGAL_PUBLIC_ENABLED) {
    if (compact) return null;
    return (
      <p className={cls}>
        © {year} {L.productName}
      </p>
    );
  }

  const links = (
    <>
      <LegalDocLink doc="offer">Оферта</LegalDocLink>
      {" · "}
      <LegalDocLink doc="privacy">Конфиденциальность</LegalDocLink>
      {" · "}
      <LegalDocLink doc="cookies">Cookies</LegalDocLink>
      {" · "}
      <LegalDocLink doc="payments">Платежи</LegalDocLink>
    </>
  );
  if (compact) {
    return <span className={cls}>{links}</span>;
  }
  return (
    <p className={cls}>
      © {year} {L.productName}
      {" · "}
      {links}
    </p>
  );
}
